import React, { useState } from "react";
import {
  PDFDownloadLink,
  Page,
  Text,
  View,
  Document,
} from "@react-pdf/renderer";
import Select from "react-select";
import { IoCloseOutline } from "react-icons/io5";
import { AiOutlineUserAdd, AiOutlineDelete } from "react-icons/ai";
import { FiFilter } from "react-icons/fi";
import { FcRefresh } from "react-icons/fc";
import { BsDownload } from "react-icons/bs";
import { FiEdit2 } from "react-icons/fi";
import { BsArrowLeft } from "react-icons/bs";
import DashLayout from "../../layouts/DashLayout";
import Table from "../../components/Table";
import Overlay from "../../components/Overlay";
import { style, color } from "../../styles/Style";
import Action from "../../components/Action";
import { beneficiaryStatus } from "../../utils/DataSource";
import { getBeneficiries } from "../../store/actions/BenActions";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { changeFromTimeStamp } from "../../utils/changeFromTimeStamp";
import changeMonthToText from "../../utils/ChangeMonthToText";
import {
  addnewSchool,
  deleteSchool,
  getSchools,
  updateSchool,
} from "../../store/actions/SchoolsActions";
import {
  addBenSchool,
  deleteBenSchool,
  getBenSchools,
  updateBenSchool,
} from "../../store/actions/BeneficiriesSchoolsActions";
import { useDispatch } from "react-redux";
import { styles } from "../../styles/downloads";
import ContentLoader from "react-content-loader";

function School() {
  // dispatch declaration
  const dispatch = useDispatch();

  const [school, setSchool] = useState({
    id: "",
    schoolLocation: "",
    schoolName: "",
    telephoneNumber: "",
  });

  const [benSchool, setBenSchool] = useState({
    id: "",
    beneficiaryId: "",
    endDate: "",
    schoolId: "",
    startDate: "",
    studyStatus: "",
  });

  // calling reducers
  const schools = useSelector((state) => state.schools);
  const beneficiariesSchools = useSelector(
    (state) => state.beneficiriesSchools
  );
  const loaders = useSelector((state) => state.loadersState);

  const beneficiaries = useSelector((state) => state.beneficiries);

  const [openTab, setOpenTab] = useState(1);

  // overlays
  const [addBenOverlay, setAddBeneOverlay] = useState(0);
  function benOverlayController() {
    setAddBeneOverlay(!addBenOverlay);
    clearOverlayInput();
  }
  function clearOverlayInput() {
    dispatch({
      type: "SET_BEN_SCHOOL_MESSAGE",
      message: "",
    });
    dispatch({
      type: "SET_SCHOOL_MESSAGE",
      message: "",
    });

    setBenSchool({
      id: "",
      beneficiaryId: "",
      endDate: "",
      schoolId: "",
      startDate: "",
      studyStatus: "",
    });

    setSchool({
      id: "",
      schoolLocation: "",
      schoolName: "",
      telephoneNumber: "",
    });
  }
  const [filterBenOverlay, setFilterBeneOverlay] = useState(0);
  function filterOverlayController() {
    setFilterBeneOverlay(!filterBenOverlay);
  }

  const [editBenOverlay, setEditBeneOverlay] = useState(0);
  function editOverlayController(passedBenSchool) {
    setEditBeneOverlay(!editBenOverlay);

    setBenSchool({
      id: passedBenSchool.id,
      beneficiaryId: passedBenSchool.beneficiaryId,
      endDate: passedBenSchool.endDate,
      schoolId: passedBenSchool.schoolId,
      startDate: passedBenSchool.startDate,
      studyStatus: passedBenSchool.stat,
    });
  }

  const [addSchool, setAddSchool] = useState(0);
  function addSchoolController() {
    setAddSchool(!addSchool);
  }

  const [editSchool, setEditSchool] = useState(0);
  function editSchoolController(passedSchool) {
    setEditSchool(!editSchool);
    setSchool({
      id: passedSchool.id,
      schoolLocation: passedSchool.schoolLocation,
      schoolName: passedSchool.schoolName,
      telephoneNumber: passedSchool.telephoneNumber,
    });
  }
  // dropdowns
  // School dropdowns
  const [SchoolDropdown, setSchoolDropDown] = useState(0);
  // for School table
  const columns = React.useMemo(
    () => [
      {
        Header: "#",
        accessor: "count",
      },
      {
        Header: "Beneficiary",
        accessor: "beneficiary",
      },
      {
        Header: "FromDate",
        accessor: "startDate",
      },
      {
        Header: "ToDate",
        accessor: "endDate",
      },
      {
        Header: "School",
        accessor: "school",
      },
      {
        Header: "Status",
        accessor: "status",
      },
      {
        Header: "Action",
        accessor: "action",
      },
    ],
    []
  );

  // transform schools data
  let [loadedSchools, setLoadedSchools] = useState([]);
  useEffect(() => {
    setLoadedSchools([]);
    for (let i = 0; i < beneficiariesSchools.length; i++) {
      const benSchool = {
        count: i + 1,
        id: beneficiariesSchools[i].id,
        beneficiaryId: beneficiariesSchools[i].beneficiary[0].id,
        beneficiary: ` ${beneficiariesSchools[i].beneficiary[0].firstName}  
      ${beneficiariesSchools[i].beneficiary[0].lastName}`,
        startDate: changeMonthToText(beneficiariesSchools[i].startDate),
        endDate: changeMonthToText(beneficiariesSchools[i].endDate),
        school: beneficiariesSchools[i].schools.schoolName,
        schoolId: beneficiariesSchools[i].schools.id,
        stat: beneficiariesSchools[i].studyStatus,
        status: (
          <div className="py-1 px-2 rounded text-indigo-500 bg-indigo-50 font-normal fit-content">
            {beneficiariesSchools[i].studyStatus}
          </div>
        ),
        action: (
          <Action
            editAction={() => {
              editOverlayController(benSchool);
            }}
            deleteAction={() => {
              handleDelete(beneficiariesSchools[i].id);
            }}
          />
        ),
      };
      setLoadedSchools((loadedSchools) => [...loadedSchools, benSchool]);

      if (
        loaders.benSchool.deletingAction &&
        loaders.benSchool.deletingAction.deleting
      ) {
        const currentBenSchools = loadedSchools;
        const newData = currentBenSchools.map((benSchool) =>
          benSchool.id === loaders.benSchool.deletingAction.id
            ? {
              ...benSchool,
              action: (
                <div className="spinner red-spinner m-auto">
                  <div className="bounce1"></div>
                  <div className="bounce2"></div>
                  <div className="bounce3"></div>
                </div>
              ),
            }
            : benSchool
        );
        setLoadedSchools(newData);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [beneficiariesSchools, loaders.benSchool.deletingAction]);

  let [loadingBenSchools, setLoadingBenSchools] = useState([]);

  useEffect(() => {
    setLoadingBenSchools([]);
    for (let i = 0; i < 5; i++) {
      const benSchool = {
        count: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        beneficiary: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        startDate: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        endDate: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        school: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        status: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        action: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
      };
      setLoadingBenSchools((loadingBenSchools) => [
        ...loadingBenSchools,
        benSchool,
      ]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loaders.benSchool.fetchingLoaders]);

  // reload schools
  useEffect(() => {
    dispatch(getSchools());
    console.log(beneficiariesSchools[1]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // handle submit

  // handle school submit
  const handleSchoolSubmit = (e) => {
    e.preventDefault();
    if (school.id) {
      const id = school.id;
      const updatedSchool = {
        id: school.id,
        schoolLocation: school.schoolLocation,
        schoolName: school.schoolName,
        telephoneNumber: school.telephoneNumber,
      };
      dispatch(updateSchool(updatedSchool, id, closeSchoolAfterUpdating));
    } else {
      dispatch(addnewSchool(school, closeSchoolFormAfterAdding));
    }
  };

  // handle beneficiary school submit
  const handleBenSchoolSubmit = (e) => {
    e.preventDefault();
    if (benSchool.id) {
      const id = benSchool.id;
      const updatedBenSchool = {
        id: benSchool.id,
        beneficiaryId: benSchool.beneficiaryId,
        endDate: benSchool.endDate,
        schoolId: benSchool.schoolId,
        startDate: benSchool.startDate,
        studyStatus: benSchool.studyStatus,
      };
      dispatch(
        updateBenSchool(updatedBenSchool, id, closeBenSchoolAfterUpdating)
      );
    } else {
      dispatch(addBenSchool(benSchool, closeBenSchoolFormAfterAdding));
    }
  };
  // handling deletion
  const handleDelete = (id) => {
    dispatch(deleteBenSchool(id));
  };
  const handleSchoolDelete = (id) => {
    dispatch(deleteSchool(id));
  };

  // beneficiries select option
  const beneficiriesOption = [];
  for (let i = 0; i < beneficiaries.length; i++) {
    const beneficiary = {
      value: beneficiaries[i].id,
      label: beneficiaries[i].beneficiaryCode,
      name: beneficiaries[i].firstName + " " + beneficiaries[i].lastName,
    };

    beneficiriesOption.push(beneficiary);
  }

  // schools select option
  const schoolsOption = [];
  for (let i = 0; i < schools.length; i++) {
    const schoolOpt = {
      value: schools[i].id,
      label: schools[i].schoolName,
    };
    schoolsOption.push(schoolOpt);
  }
  const studyStatus = [
    {
      value: "DAY SCHOLAR",
      label: "DAY SCHOLAR",
    },
    {
      value: "ARATAHA",
      label: "ARATAHA",
    },
  ];
  // reload beneficiries
  useEffect(() => {
    dispatch(getBeneficiries());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    dispatch(getBenSchools());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const selectedBeneficiary = beneficiriesOption.find(
    (beneficiary) => beneficiary.value === benSchool.beneficiaryId
  );

  const DownloadSchools = () => (
    <Document>
      <Page style={styles.body}>
        <View style={styles.table}>
          <View style={styles.tableHeaderRow}>
            <View style={styles.tableCol}>
              <Text style={styles.tableHeaderCell}>Beneficiary</Text>
            </View>
            <View style={styles.tableCol}>
              <Text style={styles.tableHeaderCell}>From date</Text>
            </View>
            <View style={styles.tableCol}>
              <Text style={styles.tableHeaderCell}>To date</Text>
            </View>
            <View style={styles.tableCol}>
              <Text style={styles.tableHeaderCell}>School</Text>
            </View>
            <View style={styles.tableCol}>
              <Text style={styles.tableHeaderCell}>Status</Text>
            </View>
          </View>

          {beneficiariesSchools.map((benefSchool, index) => (
            <View style={styles.tableRow} key={benefSchool.id}>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>
                  {benefSchool.beneficiary.firstName}{" "}
                  {benefSchool.beneficiary.lastName}
                </Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>
                  {changeFromTimeStamp(benefSchool.startDate)}
                </Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>
                  {changeFromTimeStamp(benefSchool.endDate)}
                </Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>
                  {benefSchool.schools.schoolName}
                </Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>{benefSchool.studyStatus}</Text>
              </View>
            </View>
          ))}
        </View>
      </Page>
    </Document>
  );


  function clearErrors() {
    dispatch({
      type: "SET_BEN_SCHOOL_MESSAGE",
      message: "",
    });
    dispatch({
      type: "SET_SCHOOL_MESSAGE",
      message: "",
    });
  }

  // closing insurance after cu
  function closeSchoolFormAfterAdding() {
    addSchoolController();
    setSchool({
      id: "",
      schoolLocation: "",
      schoolName: "",
      telephoneNumber: "",
    });
  }

  function closeSchoolAfterUpdating() {
    editSchoolController({
      id: "",
      schoolLocation: "",
      schoolName: "",
      telephoneNumber: "",
    });
  }
  // closing ben insurance after cu
  function closeBenSchoolFormAfterAdding() {
    benOverlayController();
    setBenSchool({
      id: "",
      beneficiaryId: "",
      endDate: "",
      schoolId: "",
      startDate: "",
      studyStatus: "",
    });
  }

  function closeBenSchoolAfterUpdating() {
    editOverlayController({
      id: "",
      beneficiaryId: "",
      endDate: "",
      schoolId: "",
      startDate: "",
      studyStatus: "",
    });
  }
  return (
    <DashLayout>
      <div className="bg-white rounded mx-10">
        <div className="flex flex-col md:flex-row p-10 pt-10 pl-10 pb-0">
          <h2 className="font-semibold">Beneficiaries schools</h2>
          <div className="md:m-auto mt-2 md:mr-0">
            <button
              className="p-2 mr-2 rounded-md text-white bg-indigo-500 hover:bg-indigo-400 title-tip"
              onClick={() => {
                benOverlayController();
              }}
              message="Register"
            >
              <AiOutlineUserAdd />
            </button>
            <button
              className="p-2 mr-2 rounded-md text-gray-500 border border-gray-100 hover:bg-gray-100 title-tip"
              onClick={() => {
                filterOverlayController();
              }}
              message="Filter"
            >
              <FiFilter />
            </button>
            <button
              className="p-2 mr-2 rounded-md text-gray-500 border border-gray-100 hover:bg-gray-100 title-tip"
              message="Refresh"
            >
              <FcRefresh />
            </button>

            <PDFDownloadLink
              document={<DownloadSchools />}
              fileName="schools.pdf"
            >
              <button
                className="p-2 mr-2 rounded-md text-gray-500 border border-gray-100 hover:bg-gray-100 title-tip"
                message="Download"
              >
                <BsDownload />
              </button>
            </PDFDownloadLink>
          </div>
        </div>
        <div className="pb-0" />
        <div className="pb-5 px-0 pr-10 flex flex-wrap  w-full">
          {/* School table */}
          <div className="w-full">
            {(!loaders.benSchool.fetchingLoaders &&
              beneficiariesSchools.length < 1) |
              loaders.benSchool.fetchFailedMessage ? (
              <div
                className={
                  !loaders.benSchool.fetchFailedMessage
                    ? "bg-gray-100 fit-content  text-xs rounded text-center py-2 px-4 text-gray-500 font-semibold m-auto"
                    : "bg-red-100 text-xs rounded fit-content text-center py-2 px-4 text-red-500 font-semibold m-auto"
                }
              >
                <p>
                  {!loaders.benSchool.fetchFailedMessage
                    ? "No school record found"
                    : loaders.benSchool.fetchFailedMessage}
                </p>
              </div>
            ) : (
              <Table
                data={
                  loaders.benSchool.fetchingLoaders
                    ? loadingBenSchools
                    : loadedSchools
                }
                columns={columns}
              />
            )}{" "}
          </div>
        </div>
        {/*add beneficiary overlay  */}
        <div
          className={
            addBenOverlay || editBenOverlay ? "flex w-screen" : "hidden"
          }
        >
          <Overlay>
            <div className="bg-white m-auto  rounded-md">
              <div
                className={
                  loaders.benSchool.message && openTab === 1
                    ? "bg-red-100 text-xs rounded text-center py-2 text-red-500 font-semibold"
                    : "hidden"
                }
              >
                <p>{loaders.benSchool.message}</p>
              </div>

              <div
                className={
                  loaders.school.message && openTab === 2
                    ? "bg-red-100 text-xs rounded text-center py-2 text-red-500 font-semibold"
                    : "hidden"
                }
              >
                <p>{loaders.school.message}</p>
              </div>
              <div className="p-10 pb-5">
                <div className="flex">
                  <h2 className="font-semibold  w-80">
                    {addBenOverlay
                      ? "Add beneficiary to school"
                      : "Change beneficiary school info"}
                  </h2>
                  <div className="m-auto mr-0">
                    <button
                      className="flex flex-row p-1  bg-gray-300 hover:bg-gray-500 text-white text-sm rounded-full"
                      onClick={() => {
                        addBenOverlay
                          ? benOverlayController()
                          : editOverlayController({
                            id: "",
                          });
                      }}
                    >
                      <IoCloseOutline className="text-white" />{" "}
                    </button>
                  </div>
                </div>{" "}
                <div className="flex flex-wrap">
                  <div className="w-full">
                    <ul
                      className="flex mb-0 list-none flex-wrap  font-normal  flex-row w-full border-b border-gray-300"
                      role="tablist"
                    >
                      <li className="-mb-px  last:mr-0">
                        <a
                          className={
                            "text-xs   px-5 py-3 pl-0   block leading-normal" +
                            (openTab === 1
                              ? "text-indigo-500 border-b-2 border-" +
                              color +
                              "-600"
                              : "text-gray-500 bg-white")
                          }
                          onClick={(e) => {
                            e.preventDefault();
                            setOpenTab(1);
                            clearErrors();
                          }}
                          data-toggle="tab"
                          href="#link1"
                          role="tablist"
                        >
                          <i className="fas fa-space-shuttle text-base mr-1"></i>{" "}
                          Beneficiary
                        </a>
                      </li>
                      <li className="-mb-px  last:mr-0">
                        <a
                          className={
                            "text-xs   px-5 py-3 pl-0  block leading-normal " +
                            (openTab === 2
                              ? "text-indigo-500 border-b-2 border-" +
                              color +
                              "-600"
                              : "text-gray-500 bg-white")
                          }
                          onClick={(e) => {
                            e.preventDefault();
                            setOpenTab(2);
                            clearErrors();
                          }}
                          data-toggle="tab"
                          href="#link2"
                          role="tablist"
                        >
                          <i className="fas fa-cog text-base mr-1"></i> Schools
                        </a>
                      </li>
                    </ul>
                    <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-2">
                      <div>
                        <div className="tab-content tab-space">
                          <div
                            className={
                              openTab === 1 ? "flex flex-col" : "hidden"
                            }
                            id="link1"
                          >
                            <form
                              className="flex flex-col pt-3"
                              onSubmit={handleBenSchoolSubmit}
                            >
                              {/*  field */}
                              <div className="py-2 w-full">
                                <label>Beneficiary Id</label>
                                <Select
                                  options={beneficiriesOption}
                                  value={beneficiriesOption.find(
                                    (obj) =>
                                      obj.value === benSchool.beneficiaryId
                                  )}
                                  onChange={(e) =>
                                    setBenSchool({
                                      ...benSchool,
                                      beneficiaryId: e.value,
                                    })
                                  }
                                />
                              </div>
                              {/*  field */}
                              <div className="py-2 w-full">
                                <label>Name </label>
                                <div className={style.field.parentDiv}>
                                  <input
                                    type="text"
                                    className={style.field.input}
                                    value={
                                      benSchool.beneficiaryId
                                        ? selectedBeneficiary.name
                                        : ""
                                    }
                                    readOnly
                                  />
                                </div>
                              </div>
                              {/*  field */}
                              <div className="py-2  w-full">
                                <div className="flex w-full">
                                  <div>
                                    <label>FromDate </label>
                                    <div
                                      className={
                                        style.field.parentDiv + " w-1/2"
                                      }
                                    >
                                      <input
                                        type="date"
                                        className={style.field.input}
                                        value={benSchool.startDate}
                                        onChange={(e) =>
                                          setBenSchool({
                                            ...benSchool,
                                            startDate: e.target.value,
                                          })
                                        }
                                      />
                                    </div>
                                  </div>
                                  <div className="ml-auto">
                                    <label>ToDate </label>

                                    <div
                                      className={
                                        style.field.parentDiv + " w-1/2"
                                      }
                                    >
                                      <input
                                        type="date"
                                        className={style.field.input}
                                        value={benSchool.endDate}
                                        onChange={(e) =>
                                          setBenSchool({
                                            ...benSchool,
                                            endDate: e.target.value,
                                          })
                                        }
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {/*  field */}
                              <div className="py-2 w-full">
                                <label>School</label>
                                <Select
                                  options={schoolsOption}
                                  value={schoolsOption.find(
                                    (obj) => obj.value === benSchool.schoolId
                                  )}
                                  onChange={(e) =>
                                    setBenSchool({
                                      ...benSchool,
                                      schoolId: e.value,
                                    })
                                  }
                                />
                              </div>
                              {/*  field */}
                              <div className="py-2 w-full">
                                <label>Status</label>
                                <Select
                                  options={studyStatus}
                                  value={studyStatus.find(
                                    (obj) => obj.value === benSchool.studyStatus
                                  )}
                                  onChange={(e) =>
                                    setBenSchool({
                                      ...benSchool,
                                      studyStatus: e.value,
                                    })
                                  }
                                />
                              </div>
                              {/* save btn */}
                              <button
                                type="submit"
                                className={style.loginBtn}
                                disabled={loaders.benSchool.sendingLoader}
                              >
                                {!loaders.benSchool.sendingLoader ? (
                                  <p className="m-auto">
                                    {addBenOverlay ? "Save" : "Update"}
                                  </p>
                                ) : (
                                  <div className="spinner m-auto">
                                    <div className="bounce1"></div>
                                    <div className="bounce2"></div>
                                    <div className="bounce3"></div>
                                  </div>
                                )}
                              </button>
                            </form>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div className="tab-content tab-space">
                          <div
                            className={
                              openTab === 2 ? "flex flex-col" : "hidden"
                            }
                            id="link1"
                          >
                            <div className="flex w-full  flex-col py-5">
                              <button
                                className={
                                  !addSchool & !editSchool
                                    ? "p-3 text-center bg-indigo-500 hover:bg-indigo-600 rounded-md text-white font-normal mb-3"
                                    : "hidden"
                                }
                                onClick={() => {
                                  addSchoolController();
                                }}
                              >
                                {"Add school"}
                              </button>
                              <div
                                className={
                                  !addSchool & !editSchool
                                    ? "flex w-full flex-col py-5 pb-0"
                                    : "hidden"
                                }
                              >
                                {loaders.school.fetchingLoaders ? (
                                  <div className="spinner m-auto indigo-spinner">
                                    <div className="bounce1"></div>
                                    <div className="bounce2"></div>
                                    <div className="bounce3"></div>
                                  </div>
                                ) : (
                                  schools.map((School, i) => {
                                    return loaders.school.deletingAction &&
                                      loaders.school.deletingAction.id ===
                                      school.id ? (
                                      <div className="spinner m-auto red-spinner">
                                        <div className="bounce1"></div>
                                        <div className="bounce2"></div>
                                        <div className="bounce3"></div>
                                      </div>
                                    ) : (
                                      <div
                                        className={
                                          "border border-gray-300 p-3 mb-3 rounded-md bg-gray-100 flex"
                                        }
                                        key={i}
                                        onClick={() => {
                                          setSchoolDropDown(i);
                                        }}
                                      >
                                        <div className="flex flex-col mb-2 m-auto mx-0 text-start cursor-pointer">
                                          <h2 className="font-semibold m-auto ml-0">
                                            {School.schoolName}
                                          </h2>
                                          <p
                                            className={
                                              SchoolDropdown === i
                                                ? "flex  ml-0"
                                                : "hidden"
                                            }
                                          >
                                            <span>Located at </span> :
                                            {School.schoolLocation}
                                          </p>
                                          <p
                                            className={
                                              SchoolDropdown === i
                                                ? "flex  ml-0"
                                                : "hidden"
                                            }
                                          >
                                            <span>Phone</span> :
                                            {School.telephoneNumber}{" "}
                                          </p>
                                        </div>
                                        <div
                                          className={
                                            SchoolDropdown === i
                                              ? "flex flex-col ml-auto"
                                              : "hidden"
                                          }
                                        >
                                          <div className="flex m-auto fit-content">
                                            <button
                                              className="flex p-1 rounded-md border border-gray-300 hover:border-gray-300 bg-gray-300 text-gray-500 mr-2"
                                              onClick={() => {
                                                editSchoolController(school);
                                              }}
                                            >
                                              <FiEdit2 />
                                            </button>
                                            <button className="flex p-1 rounded-md border border-red-300 hover:border-red-300 bg-red-300 text-red-500 mr-2">
                                              <AiOutlineDelete
                                                onClick={() => {
                                                  handleSchoolDelete(school.id);
                                                }}
                                              />
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  })
                                )}
                              </div>
                              {/* add School */}
                              <form
                                className={
                                  addSchool || editSchool
                                    ? "flex w-full flex-col  pb-0"
                                    : "hidden"
                                }
                                onSubmit={handleSchoolSubmit}
                              >
                                <h2 className="font-semibold">
                                  {addSchool
                                    ? "Register school"
                                    : "Change school info"}
                                </h2>
                                {/*  field */}
                                <div className="py-2 w-full">
                                  <label>Name </label>
                                  <div className={style.field.parentDiv}>
                                    <input
                                      type="text"
                                      className={style.field.input}
                                      value={school.schoolName}
                                      onChange={(e) =>
                                        setSchool({
                                          ...school,
                                          schoolName: e.target.value,
                                        })
                                      }
                                    />
                                  </div>
                                  <div className="mt-2">
                                    <label>Located in </label>
                                    <div className={style.field.parentDiv}>
                                      <input
                                        type="text"
                                        className={style.field.input}
                                        value={school.schoolLocation}
                                        onChange={(e) =>
                                          setSchool({
                                            ...school,
                                            schoolLocation: e.target.value,
                                          })
                                        }
                                      />
                                    </div>
                                  </div>
                                  <div className="mt-2">
                                    <label>School phone </label>
                                    <div className={style.field.parentDiv}>
                                      <input
                                        type="text"
                                        className={style.field.input}
                                        value={school.telephoneNumber}
                                        onChange={(e) =>
                                          setSchool({
                                            ...school,
                                            telephoneNumber: e.target.value,
                                          })
                                        }
                                      />
                                    </div>
                                  </div>
                                  <button
                                    type="submit"
                                    className={style.loginBtn}
                                    disabled={loaders.school.sendingLoader}
                                  >
                                    {!loaders.school.sendingLoader ? (
                                      <p className="m-auto">
                                        {addSchool ? "Register" : "Update"}
                                      </p>
                                    ) : (
                                      <div className="spinner m-auto">
                                        <div className="bounce1"></div>
                                        <div className="bounce2"></div>
                                        <div className="bounce3"></div>
                                      </div>
                                    )}
                                  </button>
                                </div>
                                <p
                                  className={
                                    addSchool | editSchool
                                      ? "p-3 pl-0 flex rounded-md text-indigo-500 font-normal mb-3 cursor-pointer m-auto"
                                      : "hidden"
                                  }
                                  onClick={() => {
                                    addSchool
                                      ? addSchoolController()
                                      : editSchoolController();
                                  }}
                                >
                                  <BsArrowLeft className="mr-2" /> {"Back"}
                                </p>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Overlay>
        </div>
        {/* filter School overlay */}
        <div className={filterBenOverlay ? "flex w-screen" : "hidden"}>
          <Overlay>
            <div className="p-10 bg-white m-auto  rounded-md">
              <div className="flex">
                <h2 className="font-semibold my-2  w-80">
                  Filter beneficiries schools
                </h2>
                <div className="m-auto mr-0">
                  <button
                    className="flex flex-row p-1  bg-gray-300 hover:bg-gray-500 text-white text-sm rounded-full"
                    onClick={() => {
                      filterOverlayController();
                    }}
                  >
                    <IoCloseOutline className="text-white" />{" "}
                  </button>
                </div>
              </div>{" "}
              <div className="flex flex-col">
                {/*  field */}
                <div className="py-2 w-full">
                  <label>Beneficiary Id </label>
                  <div className="flex w-full">
                    <Select
                      options={beneficiaryStatus}
                      className="w-1/2 mr-2"
                    />

                    <Select options={beneficiaryStatus} className="w-1/2" />
                  </div>
                </div>
                {/*  field */}
                <div className="py-2 w-full">
                  <div className="flex">
                    <div>
                      <label>From date </label>

                      <div className={style.field.parentDiv}>
                        <input type="date" className={style.field.input} />
                      </div>
                    </div>

                    <div className="ml-auto">
                      <label>ToDate </label>

                      <div className={style.field.parentDiv}>
                        <input type="date" className={style.field.input} />
                      </div>
                    </div>
                  </div>
                </div>

                {/*  field */}
                <div className="py-2  w-full">
                  <label>Status </label>
                  <Select options={beneficiaryStatus} isMulti />
                </div>
                {/*  field */}
                <div className="py-2  w-full">
                  <label>Schools </label>
                  <Select options={beneficiaryStatus} isMulti />
                </div>
                <div className="flex">
                  {/*  field */}
                  <div className="py-2  w-full">
                    <label>Province </label>
                    <Select options={beneficiaryStatus} isMulti />
                  </div>
                  {/*  field */}
                  <div className="py-2  w-full ml-2">
                    <label>District </label>
                    <Select options={beneficiaryStatus} isMulti />
                  </div>
                </div>
                <div className="flex">
                  {/*  field */}
                  <div className="py-2  w-full">
                    <label>Sector </label>
                    <Select options={beneficiaryStatus} isMulti />
                  </div>
                  {/*  field */}
                  <div className="py-2  w-full ml-2">
                    <label>Cell </label>
                    <Select options={beneficiaryStatus} isMulti />
                  </div>
                </div>
                {/* save btn */}
                <button type="submit" className={style.loginBtn}>
                  <p className="m-auto">Apply</p>
                </button>
              </div>
            </div>
          </Overlay>
        </div>
      </div>

      <table className="table text-left table-to-export hidden" id="table-to-xls">
        <thead className="thead-dark">
          <tr>
            <th>Beneficiary Id</th>
            <th>From date</th>
            <th>To date</th>
            <th>School</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>

          {beneficiariesSchools.map((benefSchool, index) => (
            < tr >
              {/* <td>{index !== 0 ?`${benefSchool.beneficiary[index].firstName}  ${benefSchool.beneficiary[index].lastName}`:``}</td>               */}
              {/* {console.log(!index ? benefSchool.beneficiary[index] : '')} */}
              {/* {console.log( benefSchool[0])} */}
              < td > {changeFromTimeStamp(benefSchool.startDate)}</td>
              <td>{changeFromTimeStamp(benefSchool.endDate)}</td>
              <td>{benefSchool.schools.schoolName}</td>
              <td>{benefSchool.studyStatus}</td>
            </tr>
          ))}
        </tbody>
      </table >

    </DashLayout >
  );
}

export default School;
